import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApiUrl } from '../util/util';
import { get } from './http';

export interface DeploymentsResponse {
	version: string;
	deployedTimestamp: string;
}

interface DeploymentsApi {
	fetchDeploymentInfo(
		authorizationToken: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<DeploymentsResponse[]>>;
}

export default {
	fetchDeploymentInfo(
		authorizationToken: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get(
			`${getApiUrl()}/deployments/versions`,
			authorizationToken,
			config,
		);
	},
} as DeploymentsApi;
